import React from "react";

const ShapeCornerRight = ({ color = "#f0f0f0" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="113.998"
            height="113.959"
            viewBox="0 0 113.998 113.959"
        >
            <path
                id="Schnittmenge_28"
                data-name="Schnittmenge 28"
                d="M209.579,351h0v0H188V237.041H302V250.8a40.009,40.009,0,0,1-7.692,23.57l-47.662,65.408a27.15,27.15,0,0,1-9.722,8.25A27.592,27.592,0,0,1,224.454,351Z"
                transform="translate(-187.999 -237.041)"
                fill={color}
            />
        </svg>
    );
};

export default ShapeCornerRight;
